import Footer from "../../FrontPage/components/Footer/Footer";
import Header from "../../FrontPage/components/Header/Header";
import NewHeader from "../../FrontPage/LandingPage/HeaderComponent/Header";

import JoinUsForm from "../component/joinus/JoinUs";
const JoinUs = () => {
  return (
    <div>
      <Header />
      <JoinUsForm />
      <Footer />
    </div>
  );
};

export default JoinUs;
